// @flow

import {
  all,
  put,
  take,
  fork,
  cancel,
  cancelled,
  throttle,
} from 'redux-saga/effects';
import actions from '../actions';
import MacheteController from '../../controller';
import segmentationSagas from './segmentation';
import interactionSagas from './interaction';
import modelSagas from './model';

/**
 * Resize the viewer based on the controller
 * @param {*} controller - contains methods to manipulate the model, viewer and segmentation tree.
 */
function* resize(controller) {
  controller.viewer.resize();
  const { width, height } = controller.viewer;
  yield put(actions.viewer.updateMeta({ width, height }));
}

/**
 * Start up all the macheteSagas
 * @param {*} controller - contains methods to manipulate the model, viewer and segmentation tree.
 */
function* startMacheteSagas(controller) {
  yield all([
    yield throttle(32, actions.viewer.resize, resize, controller),
    yield fork(modelSagas, controller),
    yield fork(segmentationSagas, controller),
    yield fork(interactionSagas, controller),
  ]);
}

/**
 * Initialize the Machete model
 */
function* initializeMachete() {
  let forks;
  try {
    while (true) {
      const {
        payload: { container, opts },
      } = yield take(actions.viewer.init);
      const controller = new MacheteController({
        container,
        viewerOpts: opts,
        outlineColor: '#00ffff',
      });
      MacheteController.instance = controller;
      forks = yield fork(startMacheteSagas, controller);
      yield put(actions.viewer.ready());
      yield take(actions.viewer.teardown);
      yield cancel(forks);
    }
  } finally {
    if (yield cancelled()) {
      yield cancel(forks);
    }
  }
}

/**
 * Main Saga for initializing all other sagas
 */
export default function* sagas() {
  yield fork(initializeMachete);
}
